document.addEventListener("DOMContentLoaded", () => {
  function updateCardState() {
    const cardWrappers = document.querySelectorAll(".product_card_main");
    cardWrappers.forEach((wrapper) => {
      const contentwrapp =  wrapper.querySelector(".product_card_content");
      const list = wrapper.querySelector(".product_card_content_list");
      const buttonWrap = wrapper.querySelector(".product_card_content_button");
      const button = wrapper.querySelector(".product_card_content_cta");

      if (!list || !button || !buttonWrap) return;

      const isMobile = window.innerWidth <= 767;
      const actualHeight = list.scrollHeight;

      if (isMobile && actualHeight > 400) {
        // Collapse view initially
        contentwrapp.classList.add("active");
        list.style.height = contentwrapp.classList.contains("active") ? "390px" : `${actualHeight}px` ;
        buttonWrap.classList.add("active");
        list.classList.add("active");
      } else {
        // Reset for desktop or small height
        list.style.height = "auto";
        contentwrapp.classList.remove("active");
        buttonWrap.classList.remove("active");
        list.classList.remove("active");
      }

      // Button click toggle
      button.onclick = () => {
        list.classList.toggle("active");
        if (list.style.height === "390px") {
          list.style.height = `${actualHeight}px`;
        } else {
          list.style.height = "390px";
        }
      };
    });
  }

  // Run on load
  updateCardState();

  // Run on resize
  window.addEventListener("resize", updateCardState);
});